module.exports = __webpack_public_path__ + "static/img/logo_avatar.066b86e6.jpg";